// Текст документа, вставленный в чат, разбираем как файл .txt: он сохранится в «Моих документах».
const HEADING = /(?:^|\n)[ \t]*(?:[А-ЯЁ]+[ \t]+)?(?:ЗАЯВЛЕНИЕ|ДОГОВОР|ЗАПРОС|ЖАЛОБА|РЕШЕНИЕ|ОПРЕДЕЛЕНИЕ|ПОСТАНОВЛЕНИЕ|ПРИГОВОР|ПРИКАЗ|ИСКОВОЕ|ХОДАТАЙСТВО|ПРЕТЕНЗИЯ|ВОЗРАЖЕНИЯ|СОГЛАШЕНИЕ|ОТЗЫВ|СООБЩЕНИЕ)(?![А-ЯЁа-яё])[^\n]*(?:\n[ \t]*о [^\n]{0,80})?/;

export function looksLikeDocument(text: string): boolean {
  const lines = text.split("\n").filter((line) => line.trim()).length;
  return text.length >= 1200 || (text.length >= 600 && lines >= 6) || (text.length >= 120 && lines >= 3 && HEADING.test(text));
}

// Название файла — по заголовку документа («АДВОКАТСКИЙ ЗАПРОС № 15» → «Адвокатский запрос № 15.txt»).
export function textFile(text: string): File {
  const heading = text.match(HEADING)?.[0] || text.split("\n").find((line) => /[А-ЯЁа-яёA-Za-z]/.test(line)) || "";
  let name = heading.replace(/[\\/:*?"<>|]+/g, " ").replace(/\s+/g, " ").trim().slice(0, 60).trim();
  if (name && /[А-ЯЁ]{4}/.test(name)) name = name[0] + name.slice(1).toLowerCase();
  return new File([text], `${name || "Текст документа"}.txt`, { type: "text/plain" });
}
